<div class="cbta-tbl student-tbl">
	<div class="columns">
		<div class="column col-12">
			<ngx-table [configuration]="configuration" [data]="students" [columns]="columns"> </ngx-table>
		</div>
		<!-- image -->
		<ng-template #imageTpl let-row let-rowIndex="rowIndex">
			<div class="flex items-center justify-center gap-4 px-2 lg:gap-8 lg:px-4">
				<mat-checkbox (change)="onCheck($event, row)" checked></mat-checkbox>
				<app-cbta-avatar imageUrl="{{ row.imageUrl }}" name="{{ row.name }}"></app-cbta-avatar>
			</div>
		</ng-template>
		<!-- name -->
		<ng-template #nameTpl let-row let-rowIndex="rowIndex">
			<span class="text-sm font-medium text-black lg:text-base">{{ row.name }}</span>
		</ng-template>
		<!-- rank -->
		<ng-template #rankTpl let-row let-rowIndex="rowIndex">
			<span class="text-sm font-medium text-black lg:text-base">{{ getRank(row.rank) }}</span>
		</ng-template>
		<!-- id -->
		<ng-template #idTpl let-row let-rowIndex="rowIndex">
			<span class="text-sm font-medium text-black lg:text-base">{{ row.staffNumber }}</span>
		</ng-template>
		<!-- license number -->
		<ng-template #licenseNumberTpl let-row let-rowIndex="rowIndex">
			<span class="text-sm font-medium uppercase text-black lg:text-base">{{ row.licenseNumber }}</span>
		</ng-template>
		<!-- status -->
		<ng-template #statusTpl let-row let-rowIndex="rowIndex">
			@if (isPendingCandidateSignOff(row)) {
				<span class="cbta-status pending">Pending Sign Off</span>
			} @else {
				<span class="text-sm font-medium text-grey-40 lg:text-base">—</span>
			}
		</ng-template>
		<!-- action -->
		<ng-template #actionTpl let-row let-rowIndex="rowIndex">
			<div class="flex items-center justify-center gap-3">
				<button (click)="goTo(row.candidateId)" class="aa-btn action-btn">
					<img src="assets/icon_actions_view.svg" alt="view" />
				</button>
				@if ((rs.isAdmin || rs.isOfficeAdmin) && !isPendingCandidateSignOff(row)) {
					<button (click)="download(row)" class="aa-btn action-btn">
						<img src="assets/icon_actions_download.svg" alt="download" />
					</button>
				}
			</div>
		</ng-template>

		<ng-template #noResultsTemplate>
			<td [attr.colspan]="columns.length" class="h-[200px] text-center">I didn't find any results for you :(</td>
		</ng-template>
	</div>
</div>
